import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavigationMovementService {
  lastPointAreaGroupIdx: WritableSignal<number> = signal(0);
}
